import React from 'react';
import { Calendar, Clock, ArrowRight } from 'lucide-react';

function Blog() {
  const featuredPosts = [
    {
      title: "The Future of AI in Business Automation",
      excerpt: "Discover how AI is revolutionizing business processes and what it means for your company's future.",
      image: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?auto=format&fit=crop&q=80",
      date: "March 15, 2024",
      readTime: "8 min read",
      category: "AI & Technology"
    },
    {
      title: "Maximizing Customer Retention Through AI",
      excerpt: "Learn how artificial intelligence is transforming customer relationship management.",
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&q=80",
      date: "March 12, 2024",
      readTime: "6 min read",
      category: "Customer Success"
    },
    {
      title: "The Art of Lead Generation",
      excerpt: "Explore modern strategies for identifying and converting high-quality leads.",
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80",
      date: "March 10, 2024",
      readTime: "5 min read",
      category: "Marketing"
    }
  ];

  const recentPosts = [
    {
      title: "Website Design Trends for 2024",
      excerpt: "Stay ahead of the curve with these emerging web design trends.",
      date: "March 8, 2024",
      category: "Design"
    },
    {
      title: "Understanding AI Ethics in Business",
      excerpt: "A deep dive into ethical considerations when implementing AI solutions.",
      date: "March 5, 2024",
      category: "AI & Ethics"
    },
    {
      title: "Optimizing Your Customer Journey",
      excerpt: "Key strategies for creating seamless customer experiences.",
      date: "March 3, 2024",
      category: "Customer Experience"
    }
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative h-screen mx-[4.2mm] mt-[4.2mm]">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-br from-[#00ffff]/10 via-transparent to-[#ff0000]/10 animate-gradient rounded-lg z-10"></div>
          <div className="absolute inset-0 rounded-lg overflow-hidden">
            <img 
              src="https://images.unsplash.com/photo-1485827404703-89b55fcc595e?auto=format&fit=crop&q=80&w=1920&h=1080"
              alt="Blog hero"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50 rounded-lg z-20"></div>
        </div>

        <div className="relative h-full flex items-center z-30">
          <div className="max-w-7xl mx-auto px-4">
            <h1 className="text-5xl font-bold text-center text-white mb-6">Atlas AI Blog</h1>
            <p className="text-xl text-white/80 text-center max-w-3xl mx-auto">
              Insights, updates, and expert perspectives on AI, business automation, and digital transformation.
            </p>
          </div>
        </div>
      </section>

      {/* Featured Posts */}
      <div className="max-w-7xl mx-auto px-4 py-12">
        <h2 className="text-3xl font-bold text-white mb-8">Featured Articles</h2>
        <div className="grid md:grid-cols-3 gap-8">
          {featuredPosts.map((post, index) => (
            <div key={index} className="white-holographic-card rounded-xl overflow-hidden">
              <img 
                src={post.image} 
                alt={post.title}
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <div className="text-sm text-[#00ffff] mb-2">{post.category}</div>
                <h3 className="text-xl font-semibold text-gray-800 mb-3">{post.title}</h3>
                <p className="text-gray-600 mb-4">{post.excerpt}</p>
                <div className="flex items-center text-sm text-gray-500">
                  <Calendar className="h-4 w-4 mr-2" />
                  <span className="mr-4">{post.date}</span>
                  <Clock className="h-4 w-4 mr-2" />
                  <span>{post.readTime}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Recent Posts */}
      <div className="max-w-7xl mx-auto px-4 py-12">
        <h2 className="text-3xl font-bold text-white mb-8">Recent Posts</h2>
        <div className="grid md:grid-cols-3 gap-8">
          {recentPosts.map((post, index) => (
            <div key={index} className="white-holographic-card p-6 rounded-xl">
              <div className="text-sm text-[#00ffff] mb-2">{post.category}</div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">{post.title}</h3>
              <p className="text-gray-600 mb-4">{post.excerpt}</p>
              <div className="flex items-center text-sm text-gray-500">
                <Calendar className="h-4 w-4 mr-2" />
                <span>{post.date}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Newsletter Section */}
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="white-holographic-card p-12 rounded-2xl text-center">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">Stay Updated</h2>
          <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
            Subscribe to our newsletter for the latest insights on AI, automation, and digital transformation.
          </p>
          <div className="flex max-w-md mx-auto">
            <input
              type="email"
              placeholder="Enter your email"
              className="flex-1 px-4 py-2 rounded-l-lg border-2 border-r-0 border-[#00ffff] focus:outline-none"
            />
            <button className="px-6 py-2 bg-[#00ffff] text-white rounded-r-lg hover:bg-[#ff0000] transition-colors">
              Subscribe
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Blog;